// extracted by mini-css-extract-plugin
export default {"question":"DatingPreferenceMultipleChoice_question__PPOsW"};